export const MODAL_OPEN_BUTTON_TEXT = 'Add Offence';
export const STINTER_PROFILE_REF_INPUT_LABEL = 'Stinter Profile Ref';
export const STINT_REF_INPUT_LABEL = 'Related Stint';
export const REASON_INPUT_LABEL = 'Reason';
export const MODAL_TITLE = 'Add Offence';
export const STINT_REF_INPUT_VALIDATION = 'Enter a valid Stint ID';
export const CREATE_OFFENCE_SUCCESS_MSG = 'Offence successfully created.';
export const CREATE_OFFENCE_FAILED_MSG =
  'There was a problem creating an Offence.';
